module.exports = __webpack_public_path__ + "assets/596f455619cdce7f6b5ff0d597e57cae.svg";